import { splitAndCapitalFirstLetter } from './textFormatters'

export const convertToValueLabel = (value: string | number | null) => ({
  value: value?.toString() ?? '',
  label: splitAndCapitalFirstLetter(value?.toString() ?? ''),
})
